export const COMPONENT_TYPES = [
  'Reference Application',
  'Reference Infrastructure',
  'Code Library',
  'Utility',
  'Template',
] as const;

export const LIFECYCLE_OPTIONS = ['Development', 'Production'] as const;

export const SYSTEM_OPTIONS = ['Internal', 'Client'] as const;

export type ComponentType = (typeof COMPONENT_TYPES)[number];
export type LifecycleOption = (typeof LIFECYCLE_OPTIONS)[number];
export type SystemOption = (typeof SYSTEM_OPTIONS)[number];

export type RegisterWizardFormValues = {
  repoUrl: string;
  description: string;
  website: string;
  slackChannelId: string;
  type: ComponentType | '';
  lifecycle: LifecycleOption | '';
  system: SystemOption | '';
  tags: string;
};

export const emptyFormValues: RegisterWizardFormValues = {
  repoUrl: '',
  description: '',
  website: '',
  slackChannelId: '',
  type: '',
  lifecycle: '',
  system: '',
  tags: '',
};
